import { render, staticRenderFns } from "./my-base.vue?vue&type=template&id=46efa370&"
import script from "./my-base.vue?vue&type=script&lang=js&"
export * from "./my-base.vue?vue&type=script&lang=js&"
import style0 from "./my-base.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports